const { fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

function fetchTags(apiUrl) {
  const query = {
    lang: getApiLanguage(),
  };
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/lootTags',
    query,
    expectedStatus: 200,
    description: 'Fetching tags',
  });
}

module.exports = {
  fetchTags,
};
